import { TYPE } from './recordingsBar.types';

export const setDataTime = payload => ({
  type: TYPE?.SET_DATA_TIME,
  payload,
});

export const setShowContainerRecordingBar = payload => ({
  type: TYPE?.SET_SHOW_CONTAINER_RECORDING_BAR,
  payload,
});
